<template>
  <el-main class="page-content-margin-unset">
    <h3>案例信息</h3>
    <div>
      <el-form
        :model="body"
        status-icon
        :rules="rules"
        label-position="left"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm">
        <el-form-item
          label="案例名称"
          prop="title">
          <el-input
            class="dk-input"
            v-model="body.title"/>
        </el-form-item>
        <el-form-item
          label="排序"
          prop="priority">
          <el-input
            class="dk-input"
            v-model="body.priority"/>
        </el-form-item>
        <el-form-item
          label="关联品牌"
          prop="price">
          <el-input
            class="dk-input"
            v-model="body.price"/>
        </el-form-item>
        <el-form-item
          label="风格"
          prop="price">
          <el-input
            class="dk-input"
            v-model="body.price"/>
        </el-form-item>
        <el-form-item
          label="城市"
          prop="price">
          <el-input
            class="dk-input"
            v-model="body.price"/>
        </el-form-item>
        <el-form-item
          label="封面图"
          prop="img_src">
          <el-upload
            :before-upload="beforeAvatarUploadImages"
            @http-request="onImageChange"
            :action="uploadDomain"
            :multiple="false"
            :limit="1"
            :file-list="imglist"
            :on-success="onImageUploadSuccess"
            :on-preview="handlePictureCardPreview"
            :on-remove="removeImg"
            :on-exceed="onImageLimited"
            :data="uploadData"
            list-type="picture-card">
            <i class="el-icon-plus"/>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img
              width="100%"
              :src="dialogImageUrl"
              alt="">
          </el-dialog>
        </el-form-item>
        <h3>案例详情</h3>
        <el-form-item
          label="图片(1-9张)"
          prop="content">
          <el-upload
            :action="uploadDomain"
            :multiple="false"
            :limit="9"
            :file-list="detailList"
            :on-success="onImageUploadSuccessDetail"
            :on-remove="removeImgDetail"
            :on-preview="handlePictureCardPreview"
            :on-exceed="onImageLimitedDetail"
            :data="uploadData"
            :before-upload="beforeAvatarUploadDetail"
            list-type="picture-card"
            style="display:inline-block">
            <i class="el-icon-plus"/>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img
              width="100%"
              :src="dialogImageUrl"
              alt="">
          </el-dialog>
        </el-form-item>
        <el-form-item label="案例说明">
          <el-input
            class="dk-input"
            type="textarea"
            v-model="body.title" />
        </el-form-item>
        <el-form-item>
          <el-button @click="event().toBrackClick()">返 回</el-button>
          <el-button
            type="primary"
            @click="event().onSureClick('ruleForm')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>

  </el-main>
</template>

<script>
import {
  getCategory, addCommodity, editCommodity, getCommodityDetail,
} from '../../api/commodity'
import { uploadDomain } from '../../configs/env'
import qiniu from '../../jslib/qiniu'

export default {
  mixins: [qiniu],
  data() {
    return {
      uploadDomain,
      levelDialog: false,
      levelTitle: '添加规格',
      body: {
        product_no: '',
        title: '',
        sub_title: '',
        priority: '',
        first_cat: '',
        second_cat: '',
        price: '',
        original_price: '',
        is_recommend: false,
        status: 1,
        img_src: '',
        video_src: '',
        img_src_list: [],
        content: '',
        add_standard: [],
        standard: [],
        delete_standard: [],
      },
      standard: {
        name: '',
        price: '',
        img_src: '',
        priority: '',
        stock: '',
      },
      fristCategory: [],
      secondCategory: [],
      tableData: [],
      // 图片组件用的一些数据
      dialogImageUrl: '',
      dialogVisible: false,
      imglist: [],
      videoList: [],
      bannerList: [],
      detailList: [],
      standardImgList: [],
      rules: {
        product_no: [
          { required: true, message: '请输入商品编号', trigger: 'blur' },
        ],
        title: [
          { required: true, message: '请输入商品标题', trigger: 'blur' },
        ],
        sub_title: [
          { required: true, message: '请输入商品副标题', trigger: 'blur' },
        ],
        priority: [
          { required: true, message: '请输入排序', trigger: 'blur' },
        ],
        first_cat: [
          { required: true, message: '请选择二级分类', trigger: 'blur' },
        ],
        second_cat: [
          { required: true, message: '请选择二级分类', trigger: 'blur' },
        ],
        price: [
          { required: true, message: '请输入商品价格￥', trigger: 'blur' },
        ],
        original_price: [
          { required: true, message: '请输入商品原价￥', trigger: 'blur' },
        ],
        img_src: [
          { required: true, message: '请添加封面图', trigger: 'blur' },
        ],
        img_src_list: [
          { required: true, message: '请添加轮播图', trigger: 'blur' },
        ],
        content: [
          { required: true, message: '请添加详情图', trigger: 'blur' },
        ],
      },
      rules2: {
        name: [
          { required: true, message: '请输入规格', trigger: 'blur' },
        ],
        price: [
          { required: true, message: '请输入规格价格￥', trigger: 'blur' },
        ],
        img_src: [
          { required: true, message: '请添加分类图', trigger: 'blur' },
        ],
        priority: [
          { required: true, message: '请输入排序', trigger: 'blur' },
        ],
        stock: [
          { required: true, message: '请输入规格库存', trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    this.network().getCategory()
    if (!this.$route.query.uuid) return
    this.network().getCommodityDetail(this.$route.query.uuid)
  },
  methods: {
    event() {
      return {
        toBrackClick: () => {
          this.$router.go(-1)
        },
        onSureClick: (formName) => {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.handler().sure()
            } else {
              console.log('error submit!!');
            }
          });
        },
        onStandardSureClick: (formName) => {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.handler().standardSure()
            } else {
              console.log('error submit!!');
            }
          });
        },
        onFristCategoryChange: () => {
          this.body.second_cat = ''
          this.network().getCategory({ parent_uuid: this.body.first_cat })
        },
        onDelClick: (index) => {
          if (this.body.standard[index].uuid) {
            this.body.delete_standard = [].concat(
              [this.body.standard[index].uuid],
              this.body.delete_standard ? this.body.delete_standard : [],
            )
            this.body.standard = this.body.standard.filter(
              item => item.uuid !== this.body.standard[index].uuid,
            )
          }
        },
      }
    },
    network() {
      return {
        getCommodityDetail: async (body) => {
          const { status, data } = await getCommodityDetail(body)
          if (status !== 200) return
          this.handler().commodityDetail(data)
        },
        getCategory: async (body) => {
          const { status, data } = await getCategory(body)
          if (status !== 200) return
          if (body) {
            this.secondCategory = data.list
            return
          }
          this.fristCategory = data.list
        },
        addCommodity: async () => {
          const { status } = await addCommodity(this.body)
          if (status !== 200) return
          this.$notify({
            title: '新增成功',
            message: '新增商品成功',
            type: 'success',
          });
          this.$router.go(-1)
        },
        editCommodity: async () => {
          const { status } = await editCommodity(this.body)
          if (status !== 200) return
          this.$notify({
            title: '编辑成功',
            message: '编辑商品成功',
            type: 'success',
          });
          this.$router.go(-1)
        },
      }
    },
    handler() {
      return {
        // 编辑/添加规格逻辑
        standardSure: () => {
          this.levelDialog = false
          if (this.standard.uuid) { // 编辑
            this.body.standard = this.body.standard.map((item) => {
              if (item.uuid === this.standard.uuid) {
                return this.standard
              }
              return item
            })
            return
          }
          // 新增商品编辑规格
          if (this.standard.edit) {
            this.body.standard = this.body.standard.map((item) => {
              if (item.index === this.standard.index) {
                return this.standard
              }
              return item
            })
            return
          }
          // 新增
          this.standard.edit = true
          this.body.standard.push(this.standard)
        },
        // 编辑/新增数据处理
        sure: () => {
          this.handler().deleteKey()
          if (this.$route.query.uuid) {
            // 过滤
            this.body.add_standard = this.body.standard.filter(item => !item.uuid)
            this.body.standard = this.body.standard.filter(item => item.uuid)
            this.body.uuid = this.$route.query.uuid
            this.network().editCommodity()
            return
          }
          this.network().addCommodity()
        },
        // 删除接口不需要的字段
        deleteKey: () => {
          this.body.standard = this.body.standard.map((item) => {
            // eslint-disable-next-line
            !item.edit || delete item.edit
            // eslint-disable-next-line
            !Number.isInteger(item.index) || delete item.index
            return item
          })
          console.log(this.body.standard);
        },
        commodityDetail: (data) => {
          this.network().getCategory({ parent_uuid: data.first_cat })
            .then(() => {
              this.body = data
              this.body.add_standard = []
            })
          this.imglist = [{ response: { key: data.img_src }, url: this.imgDomain + data.img_src }]
          this.videoList = data.video_src
            ? [{ response: { key: data.video_src }, url: this.imgDomain + data.video_src }]
            : []
          data.content.split(',').forEach((item) => {
            this.detailList.push({
              response: { key: item },
              url: this.imgDomain + item,
            })
          })
          data.img_src_list.forEach((item) => {
            this.bannerList.push({
              response: { key: item },
              url: this.imgDomain + item,
            })
          })
        },
      }
    },
    handleCurrentChange() {
    },
    // 覆盖element-ui的上传动作
    onImageChange() {
    },
    // 放大
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    // 封面图
    onImageLimited() {
      this.$message.error('最多上传一张图片')
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isLt2M;
    },
    onImageUploadSuccess(response) {
      this.imglist.push({
        response: {
          key: response.key,
        }, // response里面的key是必须的
        url: this.imgDomain + response.key, // url也是必须的
      })
      this.body.img_src = response.key
    },
    removeImg(file, fileList) {
      this.imglist = fileList // 剩下的文件
      // eslint-disable-next-line
      this.body.img_src = fileList[0]
    },
    // 视频
    onImageLimitedVideo() {
      this.$message.error('最多上传一个视频')
    },
    handleChange(file, fileList) {
      this.videoList = fileList.slice(-3);
    },
    beforeAvatarUploadVideo(file) {
      const isJPG = file.type === 'video/mp4';
      console.log(file.type, '------------------');

      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error('上传视频只能是mp4格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传视频大小不能超过 10MB!');
      }
      this.beforeAvatarUploadImages(file)
      return isLt2M && isJPG;
    },
    onImageUploadSuccessVideo(response) {
      this.videoList.push({
        response: {
          key: response.key,
        }, // response里面的key是必须的
        url: this.imgDomain + response.key, // url也是必须的
      })
      this.body.video_src = response.key
    },
    removeImgVideo(file, fileList) {
      this.videoList = fileList // 剩下的文件
      // eslint-disable-next-line
      this.body.video_src = fileList[0]
    },
    // 轮播图
    onImageLimitedBanner() {
      this.$message.error('最多上传五张图片')
    },
    onImageUploadSuccessBanner(response) {
      this.bannerList.push({
        response: {
          key: response.key,
        }, // response里面的key是必须的
        url: this.imgDomain + response.key, // url也是必须的
      })
      this.body.img_src_list.push(response.key)
    },
    removeImgBanner(file, fileList) {
      this.bannerList = fileList // 剩下的文件
      this.body.img_src_list = []
      fileList.forEach((item) => {
        this.body.img_src_list.push(item.response.key)
      })
    },
    // 详情图
    onImageLimitedDetail() {
      this.$message.error('最多上传五张图片')
    },
    beforeAvatarUploadDetail(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      this.beforeAvatarUploadImages(file)
      return isLt2M;
    },
    onImageUploadSuccessDetail(response) {
      this.detailList.push({
        response: {
          key: response.key,
        }, // response里面的key是必须的
        url: this.imgDomain + response.key, // url也是必须的
      })
      // 如果不是数组，就转换成数组，该需求，单张变多张
      if (this.body.content.length) {
        this.body.content = `${this.body.content},${response.key}`
        return
      }
      this.body.content = response.key
    },
    removeImgDetail(file, fileList) {
      this.detailList = fileList // 剩下的文件
      // eslint-disable-next-line
      let arr = []
      fileList.forEach((item) => {
        arr.push(item.response.key)
      })
      this.body.content = arr.join(',')
    },
    // 规格图
    onImageLimitedStandard() {
      this.$message.error('最多上传一张图片')
    },
    onImageUploadSuccessStandard(response) {
      this.standardImgList.push({
        response: {
          key: response.key,
        }, // response里面的key是必须的
        url: this.imgDomain + response.key, // url也是必须的
      })
      this.standard.img_src = response.key
    },
    removeImgStandard(file, fileList) {
      this.standardImgList = fileList // 剩下的文件
      // eslint-disable-next-line
      this.standard.img_src = fileList[0]
    },
  },
  components: {
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/styles/mixins.scss';
.page-content-margin-unset{
  .dk-from{
    display: flex;
  }
  .table-top{
    @include dk-table-top;
  }
}
</style>



// WEBPACK FOOTER //
// src/vuepage/case/case-edit-user.vue